import { render, staticRenderFns } from "./EditableApplicantAdditionField.vue?vue&type=template&id=b6a3f7dc&"
import script from "./EditableApplicantAdditionField.vue?vue&type=script&lang=js&"
export * from "./EditableApplicantAdditionField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports